import { useSelector } from "react-redux";
import { PlanTable } from "@components/Common/PlanTable/PlanTable";

export const ThirdStep = ({ plan, drills, costPerMin }: IThirdStep) => {
    const { metrics: teamMetrics, info: teamInfo } = useSelector(({ team }: any) => team);

    return (
        <PlanTable
            plan={plan}
            setPlan={() => {}}
            drills={drills}
            metrics={teamMetrics || []}
            costPerMin={costPerMin}
            teamInfo={teamInfo}
            handleRemovePlan={() => {}}
            editable={false}
        />
    )
}

interface IThirdStep {
    plan: { drill_id: number, duration: number }[]
    drills: { drill_id: number, name: string }[]
    costPerMin: any[]
}

export default ThirdStep
